import React from 'react'
import PropTypes from 'prop-types'
import { camelCase } from '../../../utils/Lodash/index'
import { Chip } from '../../mui/Core/index'

function StatusChip({ status }) {
  const styleVariant = camelCase(status)

  const handleClick = () => {
    // do nothing - TypeError fix for Mui Chip component
  }

  return <Chip label={status} variant={styleVariant} onClick={handleClick} clickable={false} />
}

StatusChip.propTypes = {
  status: PropTypes.string.isRequired,
}

export default StatusChip
